import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useQuery } from "@tanstack/react-query";
import { Company } from "../types/Company";

export const GET_COMPANIES_FETCH_KEY = "GET_COMPANIES_FETCH_KEY";

export const getCompanies = async () => {
  const response = await fetcher.get(`${API.GESLUB}/companies`);
  return response.data;
};

export const useGetCompanies = () => {
  const { data, error, isPending } = useQuery<Company[]>({
    queryKey: [GET_COMPANIES_FETCH_KEY],
    queryFn: getCompanies,
  });
  return { data, error, isPending };
};
